
import axios from 'axios';
import { apiRoutes } from '../../apiRoutes';
import { authHeader } from '../../global';

import Vue from 'vue'

const state = {
    // Variables that are acessible from all componets -> global variables
    selected_langauge:'en',
    language_terms:{},
    active_languages:[]
}


const mutations = {
// Middleware to connect actions and state variable
    FETCH_ALL(state, data)
    {
        if(data)
        {
            let result = data.reduce((r,{term,value}) => (r[term]=value,r), {})
            state.language_terms = result
        }
    },
    SET_SELECTED_LANG(state, data)
    {
        state.selected_langauge = data
        localStorage.setItem("selected_langauge", data)
    },
    FETCH_ACTIVE_LANGUAGES(state, data)
    {
        if(data)
        {
            data.forEach(function(element) {
                element.is_collapsed =  false
                element.language_code = element.code
                element.language_name = element.name
                element.name =  ""
                element.desp =  ""
                element.desp_html =  ""
            });
            state.active_languages = data
        }
    }
}
const actions = {
    // All the functions that can be accessible from vue components
    fetchActiveLanguages({ commit }, data) {
        return axios.post(apiRoutes['LIST_ACTIVE_LANGUAGES'], data, authHeader())
            .then(response => {
              if(response.data.code == 1){
                commit('FETCH_ACTIVE_LANGUAGES', response.data.data)
              } else {
                commit('FETCH_ACTIVE_LANGUAGES', [])
              }
            })
            .catch(error => {
              if (error.response) {
                console.log(error.response)
                  Vue.notify({
                      group: 'notify',
                      type: 'error',
                      text: error.response.data.msg,
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
              } else {
                  console.log("Problem Querying Data!", error);
              }
          });
    },
    fetchAll({ commit }, data) {
        return axios.post(apiRoutes['LOAD_LANGUAGE_TERMS'], data, authHeader())
            .then(response => {
              if(response.data.code == 1){
                commit('FETCH_ALL', response.data.data)
              } else {
                commit('FETCH_ALL', [])
              }
            })
            .catch(error => {
              if (error.response) {
                console.log(error.response)
                  Vue.notify({
                      group: 'notify',
                      type: 'error',
                      text: error.response.data.msg,
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
              } else {
                  console.log("Problem Querying Data!", error);
              }
          });
    },
    async setSelectedLang({ commit }, data) {
        //SET_SELECTED_LANGUAGE
        commit('SET_SELECTED_LANG', data)
        await axios.post(apiRoutes['SET_SELECTED_LANGUAGE'], {language_code:data}, authHeader())
        .then(function (response) {
          if(response.data.code == 1)
          {
            commit('SET_SELECTED_LANG', data)
          }
        })
        .catch((error) => {

            if (error.response) {
                //alert(error.response.data.message)
                Vue.notify({
                    group: 'notify',
                    type: 'error',
                    text: error.response.data.message,
                    max: 5,
                    duration: 5000,
                    speed: 300
                })
            }
            else
            {
                //console.log("Problem submitting New Post", error);
                alert("Application exception")
            }
        });
    }
}

export {
    state,
    actions,
    mutations
}
  